// extracted by mini-css-extract-plugin
export var avatar = "DropdownButton-module--avatar--tBfA+";
export var container = "DropdownButton-module--container--Ehdus";
export var content = "DropdownButton-module--content--lyUmD";
export var menuItem = "DropdownButton-module--menuItem--+YmB6";
export var optionsTitle = "DropdownButton-module--optionsTitle--v5EVx";
export var textContainer = "DropdownButton-module--textContainer--BXBSC";
export var toggleButton = "DropdownButton-module--toggleButton--PH5ie";